module.exports = __webpack_public_path__ + "media/images/about-sec-69431c25.jpg";